@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
  height: 100%;
  width: 100%;
  text-align: center;

  @include for-desktop-only {
    padding-bottom: 20px;
  }
}

.contentWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
  height: 100%;
  width: 100%;
  max-width: 300px;
  text-align: center;
}

.description {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  h3 {
    font-size: 20px;
  }
}

.buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
}
